import React from "react";

//firebase
import { db } from 'assets/firebase';

//algolia full text search
import { algolia } from 'assets/algolia';


//redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { CartProductAdded } from 'redux/actions';

//styles
import withStyles from "@material-ui/core/styles/withStyles";
import shoppingCartStyle from "assets/jss/material-kit-pro-react/views/shoppingCartStyle.jsx";

//core
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";

//components
import Header from "components/Header/Header.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Footer from "components/Footer/Footer.jsx";

//keiki
import OrderDetails from "components/OrderDetails/OrderDetails.jsx";


function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
function dateConverter(UNIX_timestamp){
    var a = new Date(UNIX_timestamp * 1000);
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var year = a.getFullYear();
    var month = months[a.getMonth()];
    var date = a.getDate();
    var time = month + ' ' + date + ' ' + year;
    return time;
}

class OrderHistoryPage extends React.Component {
    constructor(props) {
      super(props);
  
      this.state = {
          orders: [],
          shipTo: 'all',
          shipToAddress: { }
        };

        this.getOrders = this.getOrders.bind(this);
        this.refreshOrders = this.refreshOrders.bind(this);

        this.refreshOrders();
    }

    getOrders(callback) {
        db.getOrdersBySchool(this.props.user.schoolID).then(orders => {
            callback(orders);
        });
    }

    refreshOrders() {
        
        var filtered = [];
        this.getOrders(orders => {
            
            for(var i = 0; i < orders.length; i++) {
    
                if(!orders[i].tax)
                    orders[i].tax = 0;
                orders[i].tax = orders[i].tax.toFixed(2);

                if(!orders[i].orderTotal)
                    orders[i].orderTotal = 0;
                orders[i].orderTotal = Number(orders[i].orderTotal).toFixed(2);

                orders[i].orderPlaced = new Date(orders[i].orderPlaced).toLocaleDateString();

                filtered.push(orders[i]);    
            
            }

            this.setState({orders: filtered});
        });
    }

    reOrder(order) {
        console.log(order);
        for(var i = 0; i < order.items.length; i++) {
            this.addProductToCart(order.items[i]);
        }
    }

    addProductToCart(item) {

        algolia.searchProducts(item.productID).then(results => {

            var product = results[0];

            // set image property
            if(!product.thumbnail) {
                product.thumbnail = "/missingImage.jpg";
            }
            if(!product.photo) {
                product.photo = "/missingImage.jpg";
            }

            // apply custom pricing

            product.qty = item.qty;
            this.props.onCartProductAdded(product);
        })
    }

    showNoResults() {
        if(this.state.orders.length === 0) {
            return "block";
        } else {
            return "none";
        }
    }

    
    render() {
        const { classes } = this.props;
    
        return (
          <div>
            <Header
              brand="All Things EQ"
              links={<HeaderLinks dropdownHoverColor="info" />}
              fixed
              color="dark"
            />
            <div className={classes.container} style={{minHeight:"369px", marginTop:"100px"}}>
                <GridContainer>
                    <GridItem xs={12}>
                        <h3 className={classes.cardTitle}>Quote / Order History</h3>
                    </GridItem>
                    
                    <GridItem xs={12}>
                        <Card>
                            <CardBody>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{paddingRight:"3px"}}>
                                            </TableCell>
                                            <TableCell style={{paddingRight:"3px"}}>
                                                Order Date
                                            </TableCell>
                                            <TableCell style={{paddingRight:"3px"}}>
                                                Order Placed By
                                            </TableCell>
                                            <TableCell style={{paddingRight:"3px"}}>
                                                Total
                                            </TableCell>
                                            <TableCell style={{paddingRight:"3px"}}>
                                                Status
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.orders.map((order,index) => (
                                        <TableRow key={index}>
                                            <TableCell style={{paddingRight:"3px"}}>
                                                <OrderDetails order={order} />
                                            </TableCell>
                                            <TableCell style={{paddingRight:"3px"}}>
                                                {dateConverter(order.created)}
                                            </TableCell>
                                            <TableCell style={{paddingRight:"3px"}}>
                                                {order.userName}                                        
                                            </TableCell>
                                            <TableCell style={{paddingRight:"3px"}}>
                                                ${numberWithCommas(order.orderTotal)}
                                            </TableCell>    
                                            <TableCell style={{paddingRight:"3px"}}>
                                                {order.status}
                                            </TableCell>
                                        </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </CardBody>
                        </Card>
                        
                    </GridItem>

                    <GridItem xs={12} style={{display:this.showNoResults(), textAlign:"center", color:"maroon", fontSize:"12px", marginTop:"50px"}}>
                        Sorry, we did not find any orders.
                    </GridItem>
                </GridContainer>
            </div>
            <Footer
                content={
                    <div>
                    <div className={classes.right} style={{fontSize:"13px"}}>
                        &copy; {1900 + new Date().getYear()} Ecclesia, Inc.
                    </div>
                    </div>
                }
            />
          </div>
        );
    }
}

const mapStateToProps = state => {
  return state;
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({onCartProductAdded: CartProductAdded }, dispatch);  
}

OrderHistoryPage = connect(mapStateToProps, mapDispatchToProps)(OrderHistoryPage);
export default withStyles(shoppingCartStyle)(OrderHistoryPage);



// WEBPACK FOOTER //
// ./src/views/OrdersPage/OrdersPage.jsx